import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { SensorWarrantyCheckGridComponent } from './sensor-warranty-check-grid.component';
import { SensorFailureManagementGridComponent } from './sensor-failure-management-grid.component';
import { TabsModule } from 'primeng/tabs';

@Component({
  templateUrl: './sensor-fail.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./sensor-replace.component.scss'],
  imports: [SensorFailureManagementGridComponent, SensorWarrantyCheckGridComponent, TabsModule]
})
export class SensorFailComponent {

}
